// extracted by mini-css-extract-plugin
export default {"body":"CustomSwitch_body__h4Ayr","track":"CustomSwitch_track__h6VaQ","thumb":"CustomSwitch_thumb__f18+C"};